module.exports = __webpack_public_path__ + "img/port.11f558f5.jpg";